import WeatherWidget from "./WeatherWidget";

export default WeatherWidget;
